module.exports = __webpack_public_path__ + "img/red_blank.88f536dc.jpg";